/* Alcedo Print: small progressive enhancements; no quote prices are calculated here. */
if (!customElements.get('ap-navigation')) {
  customElements.define('ap-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        this.querySelectorAll('details[open]').forEach((menu) => {
          if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
        });
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const menu = event.target.closest('details[open]');
        if (menu) { menu.open = false; menu.querySelector('summary').focus(); event.preventDefault(); }
      }, options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

(() => {
  const isSlovenian = () => String(document.documentElement.lang || '').toLowerCase().startsWith('sl');

  function updateBatch(form) {
    const total = form.querySelector('[data-ap-total]');
    const batch = form.querySelector('[data-ap-batch]');
    if (!total || !batch) return;
    const limit = Number(total.value);
    if (limit > 0) batch.max = String(limit); else batch.removeAttribute('max');
    batch.setCustomValidity(batch.value && limit > 0 && Number(batch.value) > limit
      ? (isSlovenian() ? 'Količina na dobavo ne sme presegati skupne količine.' : 'Parts per delivery cannot exceed the total quantity.')
      : '');
  }

  function updatePersonalisation(input) {
    const output = input.id ? document.querySelector(`[data-ap-preview-for="${CSS.escape(input.id)}"]`) : null;
    if (output) output.textContent = input.value.trim() || (isSlovenian() ? 'Vaše besedilo' : 'Your text here');
    input.setCustomValidity(input.required && !input.value.trim()
      ? (isSlovenian() ? 'Vnesite zahtevano besedilo za ta izdelek.' : 'Enter the required text for this product.')
      : '');
  }

  function parseSetSizeValue(value) {
    const match = String(value || '').match(/\b([1-6])\b/);
    return match ? Number(match[1]) : null;
  }

  function findSetSize(root) {
    const container = root.closest('.product__info-container') || root.closest('product-info') || document;
    const optionGroups = container.querySelectorAll('variant-selects .product-form__input');
    const nameHints = ['set size', 'pack size', 'set quantity', 'quantity in set', 'količina v kompletu', 'stevilo kosov', 'število kosov', 'količina kompleta'];

    for (const group of optionGroups) {
      const label = group.querySelector('legend, .form__label');
      const optionName = String(label?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!nameHints.some((hint) => optionName.includes(hint))) continue;
      const checked = group.querySelector('input[type="radio"]:checked');
      const select = group.querySelector('select');
      const parsed = parseSetSizeValue(checked?.value || select?.value || '');
      if (parsed) return parsed;
    }

    // Fallback: when only one product option exists and its selected value is simply 1–6 pieces.
    if (optionGroups.length === 1) {
      const group = optionGroups[0];
      const checked = group.querySelector('input[type="radio"]:checked');
      const select = group.querySelector('select');
      const parsed = parseSetSizeValue(checked?.value || select?.value || '');
      if (parsed) return parsed;
    }
    return 1;
  }

  function updateMultiPersonalisation(root) {
    if (!root || root.dataset.apMulti !== 'true') return;
    const max = Number(root.dataset.apMaxItems || 6);
    const count = Math.max(1, Math.min(max, findSetSize(root) || 1));
    root.querySelectorAll('[data-ap-personalisation-item]').forEach((item) => {
      const index = Number(item.dataset.apPersonalisationItem || 1);
      const active = index <= count;
      item.hidden = !active;
      item.querySelectorAll('input,select,textarea').forEach((control) => {
        control.disabled = !active;
        if (active && control.matches('[data-ap-personalisation]')) updatePersonalisation(control);
      });
    });
  }

  function validateAssociatedControls(form) {
    const controls = Array.from(form.elements).filter((el) => el.matches?.('[data-ap-personalisation]'));
    controls.forEach(updatePersonalisation);
    document.querySelectorAll(`[data-ap-personalisation-root]`).forEach((root) => {
      const rootControls = Array.from(root.querySelectorAll('input,select,textarea'));
      if (rootControls.some((control) => control.form === form)) updateMultiPersonalisation(root);
    });
  }

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input.matches?.('[data-ap-personalisation]')) updatePersonalisation(input);
    if (input.matches?.('[data-ap-total], [data-ap-batch]')) updateBatch(input.form);
  });

  document.addEventListener('change', (event) => {
    if (!event.target.closest?.('variant-selects')) return;
    const productInfo = event.target.closest('product-info') || event.target.closest('.product__info-container')?.parentElement || document;
    productInfo.querySelectorAll?.('[data-ap-personalisation-root][data-ap-multi="true"]').forEach(updateMultiPersonalisation);
    // Dawn can update product info asynchronously after a variant selection.
    setTimeout(() => productInfo.querySelectorAll?.('[data-ap-personalisation-root][data-ap-multi="true"]').forEach(updateMultiPersonalisation), 60);
  });

  // Dawn uses novalidate and an AJAX add-to-cart handler. Validate our associated
  // fields in capture phase before that handler can add an incomplete product.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    validateAssociatedControls(form);
    if (form.classList.contains('ap-form')) updateBatch(form);
    const hasPersonalisation = Array.from(form.elements).some((el) => el.closest?.('.ap-personalisation') || el.matches?.('[data-ap-personalisation]'));
    if ((hasPersonalisation || form.classList.contains('ap-form')) && !form.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function initialise(root = document) {
    root.querySelectorAll?.('.ap-form').forEach(updateBatch);
    root.querySelectorAll?.('[data-ap-personalisation]').forEach(updatePersonalisation);
    root.querySelectorAll?.('[data-ap-personalisation-root]').forEach((personalisationRoot) => {
      updateMultiPersonalisation(personalisationRoot);
      personalisationRoot.querySelectorAll('[data-ap-personalisation]').forEach((input) => input.form?.removeAttribute('novalidate'));
      personalisationRoot.querySelectorAll('input[required],select[required],textarea[required]').forEach((input) => input.form?.removeAttribute('novalidate'));
    });
  }

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

// Open the installed 3D quote launcher when a calculator section has no inline app block.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-ap-open-quote-launcher]');
  if (!trigger) return;
  const candidates = Array.from(document.querySelectorAll('button, a')).filter((el) => el !== trigger);
  const launcher = candidates.find((el) => {
    const label = `${el.getAttribute('aria-label') || ''} ${el.textContent || ''}`.trim().toLowerCase();
    return label.includes('3d print quote') || label.includes('3d quote');
  });
  if (launcher) launcher.click();
});

// Alcedo Print v4: language selector + visually suppress the fixed 3D quote launcher.
(() => {
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ap-language-select]');
    if (select?.form) select.form.submit();
  });

  const launcherLabels = ['calculate 3d print price', 'get a 3d print quote', '3d print quote'];
  const normalized = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function hideLauncherInRoot(root) {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll('button,a,[role="button"]').forEach((element) => {
      const label = normalized(`${element.getAttribute('aria-label') || ''} ${element.textContent || ''}`);
      if (!launcherLabels.some((needle) => label.includes(needle))) return;
      let node = element;
      let fixedNode = null;
      for (let depth = 0; node && depth < 7; depth += 1, node = node.parentElement) {
        try {
          const style = getComputedStyle(node);
          if (style.position === 'fixed') { fixedNode = node; break; }
        } catch (_) {}
      }
      if (fixedNode) {
        fixedNode.dataset.apQuoteLauncherHidden = 'true';
        fixedNode.style.setProperty('display', 'none', 'important');
      }
    });
    root.querySelectorAll('iframe').forEach((frame) => {
      const label = normalized(`${frame.getAttribute('title') || ''} ${frame.getAttribute('aria-label') || ''} ${frame.getAttribute('src') || ''}`);
      if (!(label.includes('3d print') || label.includes('3d-print') || label.includes('quote-launcher'))) return;
      let node = frame;
      let fixedNode = null;
      for (let depth = 0; node && depth < 7; depth += 1, node = node.parentElement) {
        try {
          if (getComputedStyle(node).position === 'fixed') { fixedNode = node; break; }
        } catch (_) {}
      }
      if (fixedNode) {
        fixedNode.dataset.apQuoteLauncherHidden = 'true';
        fixedNode.style.setProperty('display', 'none', 'important');
      }
    });
    root.querySelectorAll('*').forEach((node) => {
      if (node.shadowRoot) hideLauncherInRoot(node.shadowRoot);
    });
  }

  let attempts = 0;
  const hideLauncher = () => {
    hideLauncherInRoot(document);
    attempts += 1;
    if (attempts < 20) setTimeout(hideLauncher, 500);
  };
  hideLauncher();
  const observer = new MutationObserver(() => hideLauncherInRoot(document));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

// Keep Upload-Lift file URLs with custom Shopify contact enquiries.
// Upload-Lift is product-targeted, while Signs & Logos and Series Production submit
// Shopify contact forms. Mirror successful upload URLs into hidden contact fields.
(() => {
  const selector = '.ap-request--signs form.ap-form, .ap-request--series form.ap-form';

  function uploadForm() {
    return document.querySelector(selector);
  }

  function syncUploadLink(file, remove = false) {
    const form = uploadForm();
    const url = String(file?.url || file?.downloadUrl || '').trim();
    if (!form || !url) return;

    const existing = Array.from(form.querySelectorAll('input[data-ap-upload-link]'))
      .find((input) => input.value === url);
    if (remove) {
      existing?.remove();
      renumberUploadLinks(form);
      return;
    }
    if (existing) return;

    const input = document.createElement('input');
    input.type = 'hidden';
    input.value = url;
    input.dataset.apUploadLink = 'true';
    form.appendChild(input);
    renumberUploadLinks(form);
  }

  function renumberUploadLinks(form) {
    form.querySelectorAll('input[data-ap-upload-link]').forEach((input, index) => {
      input.name = `contact[Uploaded file ${index + 1}]`;
    });
  }

  window.addEventListener('upload:added', (event) => syncUploadLink(event.detail, false));
  window.addEventListener('upload:removed', (event) => syncUploadLink(event.detail, true));
})();

// v6.9.7: language links are direct links; force navigation on tap/click as a fallback.
document.addEventListener('click', (event) => {
  const link = event.target.closest?.('a[data-ap-language-link]');
  if (!link) return;
  const href = link.getAttribute('href');
  if (!href) return;
  event.preventDefault();
  window.location.assign(href);
});
